export { addStyle } from '@nitipit/adapter/src/adapter';
